/**
 * 区域管理
 */
<template>
  <div>
    <!-- 引入任务管理 -->
    <div v-show="isShow" style="margin: 6px">
      <!-- 面包屑导航 -->
      <!--列表-->
      <div>
        <el-row :gutter="24">
          <el-col :span="16">
            <el-card class="box-card">
              <div id="containerMap"></div>
            </el-card>
            <el-card class="box">
              <el-timeline :reverse="reverse" style="height: 220px; overflow-y: auto">
                <el-timeline-item placement="top" type="primary " v-for="(item, index) in historyData" :key="index"
                  :timestamp="item.time_str">
                  {{ item.user }}{{ item.title }}
                </el-timeline-item>
              </el-timeline>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card class="boxs">
              <el-row :gutter="24">
                <el-col :span="14">
                  <div class="text item">
                    车辆编号：<span class="txt">{{ carData.vin }}</span>
                  </div>
                  <div class="text item">
                    车&nbsp;&nbsp;牌&nbsp;&nbsp;号：<span class="txt">{{
    carData.car_number
}}</span>
                  </div>
                  <div class="text item">
                    车辆型号：<span class="txt">{{ carData.name }}</span>
                  </div>
                  <div class="text item">
                    车辆类型：<span class="txt">{{ carData.code }}</span>
                  </div>
                  <div class="text item">
                    当前位置：
                    <p class="txt" style="width: 80%; margin-top: -20px; margin-left: 70px;margin-bottom:-20px">
                      {{ gps }}
                    </p>
                  </div>
                  <div class="text item">
                    所属区域：<span class="txt">{{ carData.group }}</span>
                  </div>
                  <div class="text item">
                    数据时间：<span class="txt">{{
    carData.last_upload_data_time
}}</span>
                  </div>
                  <div class="text item">
                    运行状态：<span class="txt">{{ carData.runStatus }}</span>
                  </div>
                  <div class="text item">
                    急停状态：<span class="txt">{{ carData.stop_status }}</span>
                  </div>
                  <div class="text item">
                    当前电压：<span class="txt">{{ carData.current_total_voltage }}V</span>
                  </div>
                  <div class="text item">
                    当前电流：<span class="txt">{{ carData.current_total_current }}A</span>
                  </div>
                  <div class="text item">
                    车辆速度：<span class="txt">{{ carData.car_speed }}Km/h</span>
                  </div>
                  <div class="text item">
                    电机转速：<span class="txt">{{ carData.motor_speed }}r</span>
                  </div>
                  <div class="text item">
                    程序编号：<span class="txt">{{ carData.program_version }} </span>
                  </div>
                </el-col>
                <el-col :span="10">
                  <div class="text item">
                    驾驶模式：<span class="txt">{{ carData.drive_mode }}</span>
                  </div>
                  <div class="text item">
                    电机扭矩：<span class="txt">{{ carData.motor_speed }}km</span>
                  </div>
                  <div class="text item">
                    控制器温度：<span class="txt">{{ carData.motor_controller_temperature }}°C</span>
                  </div>
                  <div class="text item">
                    电机温度：<span class="txt">{{ carData.drive_motor_temperature }}°C</span>
                  </div>
                  <div class="text item">
                    当前挡位：<span class="txt">{{ carData.gear }}</span>
                  </div>
                  <div class="text item">
                    母线电流：<span class="txt">{{ carData.motor_controller_bus_current }}A</span>
                  </div>
                  <div class="text item">
                    母线电压：<span class="txt">{{ carData.motor_controller_input_voltage }}V</span>
                  </div>
                  <div class="text item">
                    转向角度：<span class="txt">{{ carData.current_angle }}°</span>
                  </div>
                  <div class="text item">
                    EPS温度：<span class="txt">{{ carData.steering_motor_temperature }}°C</span>
                  </div>
                  <div class="text item">
                    EPS电流：<span class="txt">{{ carData.steering_motor_current }}A</span>
                  </div>
                  <div class="text item">
                    累计里程：<span class="txt">{{ carData.total_mileage }}Km</span>
                  </div>
                  <div class="text item">
                    制动状态：<span class="txt">{{
    carData.braking_state
}}</span>
                  </div>
                  <div class="text item">
                    剩余电量：<span class="txt">{{ carData.electricity }}%</span>
                  </div>
                  <div class="text item">
                    充电状态：<span class="txt">{{
    carData.charging_status
                      }}</span>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import {
  get_detail_list,
  get_history_list,
  get_car_position,
} from "../../api/car_supervise/Regulatory_details";
let conMap = "";
let marker = "";
let map_status = true;
import AMap from "AMap";
export default {
  data() {
    return {
      loading: false, //是显示加载
      isShow: true,
      activeName: "first",
      carData: {},
      gps: "",
      reverse: false,
      historyData: [],
      position: [],
      planeType: "",
      course: "",
      operationType: [
        {
          value: 1,
          label: "添加",
        },
        {
          value: 2,
          label: "修改",
        },
        {
          value: 3,
          label: "删除",
        },
        {
          value: 4,
          label: "导入",
        },
        {
          value: 5,
          label: "导出",
        },
      ],
      operationStatus: [
        {
          value: 1,
          label: "保养",
        },
        {
          value: 2,
          label: "验收",
        },
        {
          value: 3,
          label: "事故",
        },
        {
          value: 4,
          label: "维保",
        },
        {
          value: 5,
          label: "调度",
        },
      ],
      timer: null
    };
  },
  // 注册组件
  props: {
    vin: String,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    map_status = true;
    this.getDataDetail();
  },
  mounted() {
    this.getHistoryData();
    this.createMap();
    this.timer = setInterval(() => {
      this.getDataDetail();
      this.guiji();
    }, 1000);
  },
  destroyed() {
    map_status = false;
    clearInterval(this.timer);
    conMap && conMap.destroy();
    marker = ""
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    createMap() {
      get_car_position(this.vin).then((res) => {
        this.planeType = res.data.gps_code;
        if (res["code"] === 0) {
          if (this.position[0] === 0 && this.position[1] === 0) {
            //创建地图
            if (map_status) {
              conMap = new AMap.Map("containerMap", {
                resizeEnable: true, //是否监控地图容器尺寸变化
                zoom: 18, //初始化地图层级
                center: [118.216513, 36.810216], //初始化地图中心点
              })
            }
          } else {
            //创建地图
            AMap.convertFrom(([res.data.longitude, res.data.latitude]), this.planeType, function (status, result) {
              if (result.info === 'ok') {
                var resLnglat = result.locations[0];
                if (map_status) {
                  conMap = new AMap.Map("containerMap", {
                    resizeEnable: true, //是否监控地图容器尺寸变化
                    zoom: 18, //初始化地图层级
                    center: [resLnglat.lng, resLnglat.lat], //初始化地图中心点
                  });
                }
              }
            });

          }
        }
      });

    },
    guiji() {
      get_car_position(this.vin).then((res) => {
        this.planeType = res.data.gps_code;
        this.course = res.data.course;

        if (res["code"] !== 0) {
          return;
        }

        if (res.data.longitude === 0 && res.data.latitude === 0) {
          var viaMarker = new AMap.Marker({
            position: new AMap.LngLat(118.216513, 36.810216),
          });
          conMap.add([viaMarker]);
          return
        }

        let that = this
        AMap.convertFrom(([res.data.longitude, res.data.latitude]), this.planeType, function (status, result) {
          if (result.info === 'ok') {
            var resLnglat = result.locations[0];
            // conMap.setCenter([resLnglat.lng, resLnglat.lat]); //设置地图中心点
            if (marker != "") {
              marker.setAngle(that.course);
              marker.setPosition([resLnglat.lng, resLnglat.lat]);
            } else {
              marker = new AMap.Marker({
                position: [resLnglat.lng, resLnglat.lat],
                content: '<img src="../../static/汽车相关-俯视车 (1).png" style="width:20px;height:20px;" />',
                angle: that.course,
              });
              if (map_status) {
                marker.setMap(conMap);
              }
            }
          }
        });


      });
    },
    // 获取区域列表
    getDataDetail() {
      get_detail_list(this.vin).then((res) => {
        if (res["code"] === 0) {
          this.carData = res.data;
          if (res.data.gps.longitude === 0 && res.data.gps.latitude === 0) {
            this.gps = "山东省淄博市临淄区金岭回族镇舜泰汽车有限公司";
          } else {
            this.getAddressData(res.data.gps);
          }
        }
      });
    },
    getAddressData(gps) {
      let that = this;
      AMap.plugin("AMap.Geocoder", function () {
        var geocoder = new AMap.Geocoder({
          city: "010", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        });
        var lnglat = [];
        var _lnglat = [];
        lnglat.push(gps.longitude);
        lnglat.push(gps.latitude);
        AMap.convertFrom(lnglat, that.carData.gps_code, function (status, result) {
          if (result.info === 'ok') {
            var resLnglat = result.locations[0];
            _lnglat.push(resLnglat.lng);
            _lnglat.push(resLnglat.lat);
            geocoder.getAddress(_lnglat, function (status, result) {
              if (status === "complete" && result.regeocode) {
                var address = result.regeocode.formattedAddress;
                that.gps = address;
              }
            });
          }
        });

      });
    },
    getHistoryData() {
      get_history_list(this.vin).then((res) => {
        if (res["code"] === 0) {
          this.historyData = res.data.data;
        }
      });
    },
  },
};
</script>

<style scoped>
#containerMap {
  width: 100%;
  height: 500px;
}

.text {
  font-size: 14px;
  color: #999;
}

.item {
  margin-top: 20px;
  margin-left: 15px;
}

.txt {
  color: #000;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.box-card {
  width: 100%;
  float: left;
  margin-bottom: 20px;
  height: 540px;
}

.boxs {
  width: 100%;
  float: left;
  height: 820px;
}

.box {
  width: 50%;
  height: 260px;
}

.amap-icon img {
  width: 25px;
  height: 34px;
}
</style>

 
    


// WEBPACK FOOTER //
// src/views/car_supervise/Regulatory_details.vue